import { useState } from 'react';
import {
    ChevronRight,
    ChevronDown,
} from 'lucide-react';
const BidderCard = ({ firm }: any) => {
    const [showDetails, setShowDetails] = useState(false);

    return (
        <div className="border rounded-lg p-4">
            <div className="flex justify-between items-start mb-4">
                <div>
                    <h3 className="font-medium flex items-center gap-2">
                        {firm.name}
                        {firm.premiumPartner && (
                            <div className="text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm bg-purple-100 text-purple-800">Premium Partner</div>
                        )}
                    </h3>
                    <p className="text-sm text-gray-500">
                        {firm.matchScore}% Match • {firm.tasks} Similar Tasks
                    </p>
                </div>
                <button className="flex items-center gap-2 mt-2 px-4 py-2 bg-green text-white rounded-lg"
                    onClick={() => setShowDetails(!showDetails)}
                >
                    {showDetails ? <ChevronDown className="w-4 h-4" /> : <ChevronRight className="w-4 h-4" />}
                </button>
            </div>

            {showDetails && (
                <>
                    <div className="grid grid-cols-2 gap-4 mb-4">
                        <div className="space-y-2">
                            <div className="text-sm text-gray-500">Expertise Areas</div>
                            <div className="flex flex-wrap gap-2">
                                {firm.expertise.map((area: any, i: number) => (
                                    <div key={i} className='text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm bg-blue-100 text-blue-80'>{area}</div>
                                ))}
                            </div>
                        </div>
                        <div className="space-y-2">
                            <div className="text-sm text-gray-500">Geography</div>
                            <div className="flex flex-wrap gap-2">
                                {firm.geography.map((region: any, i: number) => (
                                    <div key={i} className='text-xs font-medium me-2 px-2.5 py-0.5 rounded-sm bg-blue-100 text-blue-80'>{region}</div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-4 gap-4 mb-4">
                        <div>
                            <div className="text-sm text-gray-500 mb-1">Speed</div>
                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                <div className="bg-green h-2 rounded-full" style={{ width: `${firm.metrics.speed}%` }}></div>
                            </div>
                        </div>
                        <div>
                            <div className="text-sm text-gray-500 mb-1">Quality</div>
                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                <div className="bg-green h-2 rounded-full" style={{ width: `${firm.metrics.quality}%` }}></div>
                            </div>
                        </div>
                        <div>
                            <div className="text-sm text-gray-500 mb-1">Value</div>
                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                <div className="bg-green h-2 rounded-full" style={{ width: `${firm.metrics.value}%` }}></div>
                            </div>
                        </div>
                        <div>
                            <div className="text-sm text-gray-500 mb-1">Communication</div>
                            <div className="w-full bg-gray-200 rounded-full h-2.5">
                                <div className="bg-green h-2 rounded-full" style={{ width: `${firm.metrics.communication}%` }}></div>
                            </div>
                        </div>
                    </div>

                    <div className="grid grid-cols-3 gap-4 mb-4">
                        <div className="p-3 bg-gray-50 rounded-lg">
                            <div className="text-sm text-gray-500">Avg Response</div>
                            <div className="font-medium">{firm.metrics.responseTime}</div>
                        </div>
                        <div className="p-3 bg-gray-50 rounded-lg">
                            <div className="text-sm text-gray-500">Success Rate</div>
                            <div className="font-medium">{firm.metrics.successRate}</div>
                        </div>
                        <div className="p-3 bg-gray-50 rounded-lg">
                            <div className="text-sm text-gray-500">Client Return</div>
                            <div className="font-medium">{firm.metrics.returnRate}</div>
                        </div>
                    </div>

                    <div className="border-t pt-4 mt-4">
                        <div className="grid grid-cols-2 gap-4">
                            <button className="flex items-center gap-2 mt-2 px-4 py-2 bg-green text-white rounded-lg">View Profile</button>
                            <button className="flex items-center gap-2 mt-2 px-4 py-2 bg-green text-white rounded-lg">Request Proposal</button>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default BidderCard